import { Map as ImmutableMap } from 'immutable';
const initialState = ImmutableMap();
export default function (state = initialState, action) {
  if (action.meta && action.meta.request) {
    return state.set(action.meta.request.key, action.meta.request.status);
  }
  return state;
}